import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'vaSanitize',
})
export class VaSanitizePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(html: any): any {
    return this.domSanitizer.sanitize(SecurityContext.HTML, html);
  }
}
